import type { AlpineComponent } from 'alpinejs'
import Swiper from 'swiper'
import { Pagination, Navigation, A11y, Mousewheel } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/scrollbar'

export function ProductSlider(): AlpineComponent<{
  swiper: undefined | Swiper
  currentSlide: number
  init(): void
  goToSlide(idx: number): void
  discard(): void
}> {
  return {
    swiper: undefined,
    currentSlide: 0,

    init() {
      this.swiper = new Swiper(this.$refs.slider, {
        modules: [Pagination, Navigation, A11y],
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: this.$refs.pagination,
          type: 'progressbar',
        },
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev,
          disabledClass: 'opacity-50 cursor-not-allowed',
        },
        mousewheel: {
          forceToAxis: true,
        },
        on: {
          slideChange: () => {
            if (this.swiper) {
              this.$refs.counter.textContent = `${this.swiper.realIndex + 1}`
              this.currentSlide = this.swiper?.realIndex || 0
            }
          },
        },
      })
    },

    goToSlide(idx: number) {
      if (this.swiper) {
        this.swiper.slideTo(idx)
      }
    },

    discard() {
      this.swiper && this.swiper.destroy()
    },
  }
}
